<template>
  <page pageType="宠物" :resourceType="4" subPageRoute="ResourceScanSubPet" />
</template>

<script>
import page from './common/page.vue'

export default {
  components: {page},
}
</script>